import type { TPreApprovalResultItem } from './types';

// получение списка productId офферов с preApprovalStatus 'FAILED' или тех, которые все еще в статусе isPreapproving = true, но при общем статусе 'complete'
export const getFailedPreApprovalOffers = (items: TPreApprovalResultItem[], status: string) => {
  return items
    .filter(
      (result) =>
        result.offerView?.groupItem?.preApprovalStatus === 'FAILED' ||
        (status === 'complete' && result.offerView?.groupItem?.isPreapproving),
    )
    .map((result) => result.productId);
};
